/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1PersonIdAddressesMutationRequest,
  PostApiV1PersonIdAddressesMutationResponse,
  PostApiV1PersonIdAddressesPathParams,
  PostApiV1PersonIdAddresses400,
  PostApiV1PersonIdAddresses401,
  PostApiV1PersonIdAddresses404,
  PostApiV1PersonIdAddresses409,
  PostApiV1PersonIdAddresses500,
} from "../../types/personRegisterController/PostApiV1PersonIdAddresses.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1PersonIdAddresses } from "../../clients/personRegisterController/postApiV1PersonIdAddresses.ts";

export const postApiV1PersonIdAddressesMutationKey = () =>
  [{ url: "/api/v1/person/:id/addresses" }] as const;

export type PostApiV1PersonIdAddressesMutationKey = ReturnType<
  typeof postApiV1PersonIdAddressesMutationKey
>;

export function postApiV1PersonIdAddressesMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1PersonIdAddressesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1PersonIdAddressesMutationKey();
  return mutationOptions<
    PostApiV1PersonIdAddressesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddresses400
      | PostApiV1PersonIdAddresses401
      | PostApiV1PersonIdAddresses404
      | PostApiV1PersonIdAddresses409
      | PostApiV1PersonIdAddresses500
    >,
    {
      id: PostApiV1PersonIdAddressesPathParams["id"];
      data?: PostApiV1PersonIdAddressesMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return postApiV1PersonIdAddresses(id, data, config);
    },
  });
}

/**
 * @description Cria um novo endereço vinculado à pessoa. Não permite dois endereços do mesmo tipo. **(Requer Authorization para autenticação)**
 * @summary Criar endereço da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses}
 */
export function usePostApiV1PersonIdAddresses<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1PersonIdAddressesMutationResponse,
      ResponseErrorConfig<
        | PostApiV1PersonIdAddresses400
        | PostApiV1PersonIdAddresses401
        | PostApiV1PersonIdAddresses404
        | PostApiV1PersonIdAddresses409
        | PostApiV1PersonIdAddresses500
      >,
      {
        id: PostApiV1PersonIdAddressesPathParams["id"];
        data?: PostApiV1PersonIdAddressesMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1PersonIdAddressesMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1PersonIdAddressesMutationKey();

  const baseOptions = postApiV1PersonIdAddressesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1PersonIdAddressesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddresses400
      | PostApiV1PersonIdAddresses401
      | PostApiV1PersonIdAddresses404
      | PostApiV1PersonIdAddresses409
      | PostApiV1PersonIdAddresses500
    >,
    {
      id: PostApiV1PersonIdAddressesPathParams["id"];
      data?: PostApiV1PersonIdAddressesMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1PersonIdAddressesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddresses400
      | PostApiV1PersonIdAddresses401
      | PostApiV1PersonIdAddresses404
      | PostApiV1PersonIdAddresses409
      | PostApiV1PersonIdAddresses500
    >,
    {
      id: PostApiV1PersonIdAddressesPathParams["id"];
      data?: PostApiV1PersonIdAddressesMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1PersonIdAddressesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddresses400
      | PostApiV1PersonIdAddresses401
      | PostApiV1PersonIdAddresses404
      | PostApiV1PersonIdAddresses409
      | PostApiV1PersonIdAddresses500
    >,
    {
      id: PostApiV1PersonIdAddressesPathParams["id"];
      data?: PostApiV1PersonIdAddressesMutationRequest;
    },
    TContext
  >;
}
